import React, { useEffect, useState } from 'react';
import GoogleMapReact from 'google-map-react';
import '../../trips.scss';

export interface visitAddressWithLoanProps {
  visitAddress: string;
  lat: number;
  lng: number;
  loanNo: string;
  customerName?: string;
  status?: string;
}

interface MapComponentProps {
  apiKey: string;
  startingPoint: { lat: number; lng: number };
  visitLocations: visitAddressWithLoanProps[];
}

const FieldAssignmentsMapping: React.FC<MapComponentProps> = ({ apiKey, visitLocations, startingPoint }) => {
  const [map, setMap] = useState<google.maps.Map | null>(null);
  const [directionsService, setDirectionsService] = useState<google.maps.DirectionsService | null>(null);
  const [directionsRenderer, setDirectionsRenderer] = useState<google.maps.DirectionsRenderer | null>(null);
  const [coordinates, setCoordinates] = useState<{ lat: number; lng: number }[]>([]);

  const onGoogleApiLoaded = (map: google.maps.Map, maps: any) => {
    setMap(map);
    setDirectionsService(new window.google.maps.DirectionsService());
    setDirectionsRenderer(new window.google.maps.DirectionsRenderer({ map: map, suppressMarkers: true }));
  }

  const checkPrecision = (lat1: number, lng1: number, lat2: number, lng2: number, precision: number): boolean => {
    const factor = Math.pow(10, precision);
    return (Math.round(lat1 * factor) === Math.round(lat2 * factor)) &&
           (Math.round(lng1 * factor) === Math.round(lng2 * factor));
  }

  const getMatchingLocation = (visitLocations:visitAddressWithLoanProps[], lat: number, lng: number): visitAddressWithLoanProps| undefined => {
    // Define the precision levels (up to 3 decimal places)
    const precisions = [3, 2, 1];
  
    for (let precision of precisions) {
      const location = visitLocations.find((location: visitAddressWithLoanProps) => checkPrecision(location.lat, location.lng, lat, lng, precision));
      if(location){
        return location;
      }
    }

    return undefined;
  }

  const addCustomMarkers = (result: any) => {
    const route = result.routes[0];
    const legs = route.legs;

    legs.forEach((leg: any, legIndex: number) => {


      if (legIndex === 0) {
        const marker = new google.maps.Marker({
          position: leg.start_location,
          map: map
        });
        marker.setIcon({
          url: "https://pewise-public.s3.ap-south-1.amazonaws.com/attachments/images/topBike.jpeg",
          scaledSize: new google.maps.Size(30, 30),
        });

        const infoWindow = new google.maps.InfoWindow({
          content: `User recent login location`
        });
        marker.addListener('mouseover', () => {
          infoWindow.open(map, marker);
        });

        marker.addListener("mouseout", () => {
          setTimeout(() => {
            infoWindow.close();
          }, 2000)
        });

      } else {

        const latitude = leg.start_location.lat();
        const longitude = leg.start_location.lng();
        let location = getMatchingLocation(visitLocations, latitude, longitude);

        const marker = new google.maps.Marker({
          position: leg.start_location,
          map: map,
          label: {
            text: "" + (legIndex),
            className: "custom-marker-label", // Apply the custom class
          }
        });

        if(location?.status === 'Visited'){
          marker.setIcon({
            url: "https://pewise-public.s3.ap-south-1.amazonaws.com/attachments/images/map-blue.svg",
            scaledSize: new google.maps.Size(30, 30),
          });
        }

        const contentString =
        '<div id="content">' +
        '<div id="siteNotice">' +
        "</div>" +
        '<div id="bodyContent">' +
        `<p><b>LoanNo:</b> ${location?.loanNo}</p>` +
        `<p><b>Address:</b> ${location?.visitAddress}</p>` +
        `<p><b>Customer Name:</b> ${location?.customerName}</p>` +
        `<p><b>status:</b> ${location?.status}</p>` +
        "</div>" +
        "</div>";

        const infoWindow = new google.maps.InfoWindow({
          content: contentString,
          maxWidth: 300,
        });

        marker.addListener('mouseover', () => {
          infoWindow.open(map, marker);
        });

        marker.addListener("mouseout", () => {
          setTimeout(() => {
            infoWindow.close();
          }, 3000)
        });
      }
    });
  }

  useEffect(() => {
    const locations = visitLocations.map(loc => { return { lat: loc.lat, lng: loc.lng }; });
    setCoordinates([startingPoint, ...locations]);
  }, [visitLocations, startingPoint]);

  // Calculate and display route when coordinates change
  useEffect(() => {
    if (!directionsService || !directionsRenderer || !map || coordinates.length < 1) return;

    const waypoints = coordinates.slice(1).map((coord) => ({
      location: new window.google.maps.LatLng(coord.lat, coord.lng),
      stopover: true,
    }));

    const request: google.maps.DirectionsRequest = {
      origin: new window.google.maps.LatLng(coordinates[0].lat, coordinates[0].lng),
      destination: new window.google.maps.LatLng(coordinates[0].lat, coordinates[0].lng),
      waypoints: waypoints,
      optimizeWaypoints: true,
      travelMode: google.maps.TravelMode.DRIVING,
    };

    directionsService.route(request, (response, status) => {
      if (status === google.maps.DirectionsStatus.OK) {
        directionsRenderer.setDirections(response);

        // customizeMarkers(response);
        addCustomMarkers(response);

        // var route = response?.routes[0];
        // addMarker(route?.legs[0]);
        // addMarker(route?.legs[route?.legs.length-1]);

      } else {
        console.error('Directions request failed due to ' + status);
      }
    });

  }, [directionsService, directionsRenderer, coordinates, map]);

  return (
    <div style={{ height: '100%', width: '100%', minHeight: "400px" }}>
      <GoogleMapReact
        bootstrapURLKeys={{ key: apiKey }}
        defaultCenter={{ lat: 17.473200, lng: 78.368020 }}
        defaultZoom={7}
        yesIWantToUseGoogleMapApiInternals
        onGoogleApiLoaded={({ map, maps }) =>
          onGoogleApiLoaded(map, maps)
        }
      >
      </GoogleMapReact>
    </div>
  );
};

export default FieldAssignmentsMapping;
